// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".landing-freelance #universes .card .card-title{font-size:1.6rem}.landing-freelance #universes .card .card-text li{list-style:none;font-size:1.2rem}\n", ""]);
// Exports
module.exports = exports;
